(function () {
  'use strict';

  var CONFIG_SCRIPT_ID = 'signup-tracking-config';
  var SIGNUP_ATTEMPT_KEY = 'signup_tracking_attempted';
  var SIGNUP_ATTEMPT_MAX_AGE_MS = 30 * 60 * 1000;
  var SIGNUP_TRACKED_KEY_PREFIX = 'signup_tracking_tracked_';
  var SMART_LINK_ATTRIBUTION_KEY = 'smart_link_attribution';
  var SMART_LINK_ATTRIBUTION_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
  var SMART_LINK_VIEW_KEY_PREFIX = 'smart_link_view_tracked_';
  var SMART_LINK_SIGNUP_TRACKED_KEY_PREFIX = 'smart_link_signup_tracked_';
  var SMART_LINK_SOURCE = 'shopify_theme_extension';
  var CUSTOMER_PRIVACY_FEATURE = {
    name: 'consent-tracking-api',
    version: '0.1'
  };

  var state = (window.__signupTracking = window.__signupTracking || {
    formListenerAttached: false,
    googleJsStarted: false,
    googleTags: {},
    metaPixels: {},
    smartLinkViewRequests: {},
    smartLinkSignupRequests: {}
  });
  state.googleTags = state.googleTags || {};
  state.metaPixels = state.metaPixels || {};
  state.smartLinkViewRequests = state.smartLinkViewRequests || {};
  state.smartLinkSignupRequests = state.smartLinkSignupRequests || {};

  function trim(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function isPlaceholder(value) {
    return trim(value).toUpperCase() === 'DUMMY';
  }

  function isValidMetaPixelId(value) {
    var normalized = trim(value);

    return normalized !== '' && !isPlaceholder(normalized) && /^\d{5,30}$/.test(normalized);
  }

  function isValidGoogleTagId(value) {
    var normalized = trim(value);
    var upper = normalized.toUpperCase();

    if (normalized === '' || upper === 'DUMMY') {
      return false;
    }

    return ['G-', 'UA-', 'AW-', 'DC-'].some(function (prefix) {
      return upper.indexOf(prefix) === 0;
    });
  }

  function isConfigured(value) {
    return trim(value) !== '' && !isPlaceholder(value);
  }

  function safeStorageGet(storage, key) {
    try {
      return storage ? storage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(storage, key, value) {
    try {
      if (storage) {
        storage.setItem(key, value);
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function safeStorageRemove(storage, key) {
    try {
      if (storage) {
        storage.removeItem(key);
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function readConfig() {
    var configElement = document.getElementById(CONFIG_SCRIPT_ID);

    if (!configElement) {
      return null;
    }

    try {
      var config = JSON.parse(configElement.textContent || '{}');

      return {
        metaPixelId: trim(config.metaPixelId),
        googleTagId: trim(config.googleTagId),
        googleAdsSendTo: trim(config.googleAdsSendTo),
        customerId: config.customerId ? String(config.customerId) : '',
        shopDomain: trim(config.shopDomain),
        shopUrl: trim(config.shopUrl),
        currentPath: trim(config.currentPath),
        smartLinkProxyPath: trim(config.smartLinkProxyPath) || '/a/get_products/'
      };
    } catch (error) {
      return null;
    }
  }

  function getCurrentPath(config) {
    return config.currentPath || window.location.pathname;
  }

  function getPageMetadata(config, attribution) {
    return {
      shop: config.shopDomain,
      shopUrl: config.shopUrl,
      path: window.location.pathname,
      configuredPath: config.currentPath,
      landingPath: attribution ? attribution.landingPath : '',
      href: window.location.href,
      referrer: document.referrer,
      userAgent: window.navigator ? window.navigator.userAgent : ''
    };
  }

  function getUtmParams(params) {
    var utmParams = {};

    params.forEach(function (value, key) {
      if (key.indexOf('utm_') === 0) {
        utmParams[key] = value;
      }
    });

    return utmParams;
  }

  function getSmartLinkSlug() {
    var rawQuery;
    var firstPart;

    if (window.location.pathname.replace(/\/$/, '') !== '/code') {
      return '';
    }

    rawQuery = window.location.search.replace(/^\?/, '');
    firstPart = rawQuery.split('&')[0] || '';

    if (!firstPart || firstPart.indexOf('=') !== -1) {
      return '';
    }

    try {
      return trim(decodeURIComponent(firstPart.replace(/\+/g, ' ')));
    } catch (error) {
      return trim(firstPart);
    }
  }

  function getSmartLinkStorageKey(parts) {
    return parts
      .map(function (part) {
        return encodeURIComponent(String(part || ''));
      })
      .join('_');
  }

  function getSmartLinkAttribution() {
    var raw = safeStorageGet(window.localStorage, SMART_LINK_ATTRIBUTION_KEY);
    var attribution;

    if (!raw) {
      return null;
    }

    try {
      attribution = JSON.parse(raw);
    } catch (error) {
      safeStorageRemove(window.localStorage, SMART_LINK_ATTRIBUTION_KEY);
      return null;
    }

    if (
      !attribution ||
      !attribution.linkSlug ||
      !attribution.timestamp ||
      Date.now() - attribution.timestamp > SMART_LINK_ATTRIBUTION_MAX_AGE_MS
    ) {
      safeStorageRemove(window.localStorage, SMART_LINK_ATTRIBUTION_KEY);
      return null;
    }

    return attribution;
  }

  function captureSmartLinkAttribution(config) {
    var params = new URLSearchParams(window.location.search);
    var linkSlug = getSmartLinkSlug();
    var attribution;

    if (!linkSlug) {
      return getSmartLinkAttribution();
    }

    attribution = {
      linkSlug: linkSlug,
      landingPath: getCurrentPath(config),
      landingUrl: window.location.href,
      referrer: document.referrer,
      timestamp: Date.now(),
      utmParams: getUtmParams(params)
    };

    safeStorageSet(window.localStorage, SMART_LINK_ATTRIBUTION_KEY, JSON.stringify(attribution));
    sendSmartLinkView(config, attribution);

    return attribution;
  }

  function buildSmartLinkEndpoint(action, attribution) {
    var endpointAction = action === 'signup' ? 'confirm-signup' : 'tracking';

    return (
      '/marketing/unique-links/' +
      endpointAction +
      '/' +
      encodeURIComponent(attribution.linkSlug) +
      '/'
    );
  }

  function parseSmartLinkProxyResponse(response) {
    return response.text().then(function (text) {
      var data = null;

      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          data = { raw: text };
        }
      }

      if (!response.ok) {
        throw new Error('Smart-link request failed with status ' + response.status);
      }

      if (
        data &&
        Object.keys(data).length === 1 &&
        data.data &&
        typeof data.data === 'object' &&
        Object.keys(data.data).length === 0
      ) {
        throw new Error('Smart-link proxy route is not implemented');
      }

      return data;
    });
  }

  function postSmartLinkEvent(config, payload) {
    var proxyPath = config.smartLinkProxyPath || '/a/get_products/';

    return fetch(proxyPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(parseSmartLinkProxyResponse);
  }

  function sendSmartLinkView(config, attribution) {
    var viewKey = getSmartLinkStorageKey([
      SMART_LINK_VIEW_KEY_PREFIX,
      attribution.linkSlug
    ]);

    if (safeStorageGet(window.localStorage, viewKey) || state.smartLinkViewRequests[viewKey]) {
      return;
    }

    state.smartLinkViewRequests[viewKey] = true;

    postSmartLinkEvent(config, {
      type: 'smart_link_tracking',
      targetPath: buildSmartLinkEndpoint('view', attribution),
      target_path: buildSmartLinkEndpoint('view', attribution),
      linkSlug: attribution.linkSlug,
      link_slug: attribution.linkSlug,
      extraData: {
        action: 'signup_view',
        source: SMART_LINK_SOURCE,
        landingPath: attribution.landingPath,
        landingUrl: attribution.landingUrl,
        capturedAt: attribution.timestamp,
        utmParams: attribution.utmParams,
        page: getPageMetadata(config, attribution)
      }
    })
      .then(function () {
        safeStorageSet(window.localStorage, viewKey, String(Date.now()));
      })
      .catch(function (error) {
        state.lastSmartLinkError = error && error.message ? error.message : String(error);
        state.smartLinkViewRequests[viewKey] = false;
      });
  }

  function getCustomerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function isConsentGranted(value) {
    return value === true || value === 'yes' || value === 'true' || value === 1 || value === '1';
  }

  function hasTrackingConsent() {
    var customerPrivacy = getCustomerPrivacy();
    var consent;
    var userCanBeTracked;

    if (!customerPrivacy) {
      return false;
    }

    try {
      if (typeof customerPrivacy.userCanBeTracked === 'function') {
        userCanBeTracked = customerPrivacy.userCanBeTracked();

        if (typeof userCanBeTracked === 'boolean') {
          return userCanBeTracked;
        }
      }

      if (typeof customerPrivacy.currentVisitorConsent === 'function') {
        consent = customerPrivacy.currentVisitorConsent();

        if (consent && typeof consent === 'object') {
          return isConsentGranted(consent.analytics) && isConsentGranted(consent.marketing);
        }
      }

      return false;
    } catch (error) {
      return false;
    }
  }

  function withCustomerPrivacy(callback) {
    if (getCustomerPrivacy()) {
      callback();
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([CUSTOMER_PRIVACY_FEATURE], function (error) {
        if (!error) {
          callback();
        }
      });
    }
  }

  function loadMetaPixel(pixelId) {
    if (!isValidMetaPixelId(pixelId)) {
      return false;
    }

    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) {
          return;
        }

        n = f.fbq = function () {
          if (n.callMethod) {
            n.callMethod.apply(n, arguments);
          } else {
            n.queue.push(arguments);
          }
        };

        if (!f._fbq) {
          f._fbq = n;
        }

        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }

    if (!state.metaPixels[pixelId] && typeof window.fbq === 'function') {
      window.fbq('init', pixelId);
      state.metaPixels[pixelId] = true;
    }

    return true;
  }

  function loadGoogleTag(googleTagId) {
    var script;
    var scriptId;

    if (!isValidGoogleTagId(googleTagId)) {
      return false;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        window.dataLayer.push(arguments);
      };

    if (!state.googleJsStarted) {
      window.gtag('js', new Date());
      state.googleJsStarted = true;
    }

    if (!state.googleTags[googleTagId]) {
      window.gtag('config', googleTagId);
      state.googleTags[googleTagId] = true;
    }

    scriptId = 'gtag-script-' + googleTagId.replace(/[^a-z0-9_-]/gi, '-');

    if (!document.getElementById(scriptId)) {
      script = document.createElement('script');
      script.async = true;
      script.id = scriptId;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(googleTagId);
      (document.head || document.body).appendChild(script);
    }

    return true;
  }

  function isCustomerRegistrationForm(form) {
    var formType;
    var action;

    if (!form || form.tagName !== 'FORM') {
      return false;
    }

    formType = form.querySelector('input[name="form_type"]');

    if (formType && formType.value === 'create_customer') {
      return true;
    }

    action = form.getAttribute('action') || '';

    return (
      action.indexOf('/account') !== -1 &&
      form.querySelector('[name="customer[email]"]') &&
      form.querySelector('[name="customer[password]"]')
    );
  }

  function markSignupAttempted() {
    safeStorageSet(
      window.sessionStorage,
      SIGNUP_ATTEMPT_KEY,
      JSON.stringify({
        timestamp: Date.now()
      })
    );
  }

  function getFreshSignupAttempt() {
    var raw = safeStorageGet(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
    var parsed;

    if (!raw) {
      return false;
    }

    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      safeStorageRemove(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
      return false;
    }

    if (!parsed.timestamp || Date.now() - parsed.timestamp > SIGNUP_ATTEMPT_MAX_AGE_MS) {
      safeStorageRemove(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
      return false;
    }

    return true;
  }

  function attachSignupSubmitListener() {
    if (state.formListenerAttached) {
      return;
    }

    document.addEventListener(
      'submit',
      function (event) {
        if (isCustomerRegistrationForm(event.target)) {
          markSignupAttempted();
        }
      },
      true
    );

    state.formListenerAttached = true;
  }

  function trackSignup(config) {
    var didTrack = false;

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'CompleteRegistration');
      didTrack = true;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'sign_up', {
        method: 'shopify_customer_account'
      });
      didTrack = true;

      if (isConfigured(config.googleAdsSendTo)) {
        window.gtag('event', 'conversion', {
          send_to: config.googleAdsSendTo
        });
        didTrack = true;
      }
    }

    return didTrack;
  }

  function maybeTrackPixelSignup(config) {
    var firedKey;
    var didTrack;

    if (!config.customerId || !getFreshSignupAttempt()) {
      return false;
    }

    firedKey = SIGNUP_TRACKED_KEY_PREFIX + config.customerId;

    if (safeStorageGet(window.localStorage, firedKey)) {
      return false;
    }

    didTrack = trackSignup(config);

    if (!didTrack) {
      return false;
    }

    safeStorageSet(window.localStorage, firedKey, String(Date.now()));

    if (!getSmartLinkAttribution()) {
      safeStorageRemove(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
    }

    return true;
  }

  function getSmartLinkSignupTrackedKey(attribution, customerId) {
    return getSmartLinkStorageKey([
      SMART_LINK_SIGNUP_TRACKED_KEY_PREFIX,
      attribution.linkSlug,
      customerId
    ]);
  }

  function maybeConfirmSmartLinkSignup(config) {
    var attribution = getSmartLinkAttribution();
    var trackedKey;
    var endpoint;
    var metadata;

    if (!config.customerId || !getFreshSignupAttempt() || !attribution) {
      return;
    }

    trackedKey = getSmartLinkSignupTrackedKey(attribution, config.customerId);

    if (safeStorageGet(window.localStorage, trackedKey)) {
      safeStorageRemove(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
      return;
    }

    if (state.smartLinkSignupRequests[trackedKey]) {
      return;
    }

    state.smartLinkSignupRequests[trackedKey] = true;
    endpoint = buildSmartLinkEndpoint('signup', attribution);
    metadata = getPageMetadata(config, attribution);

    postSmartLinkEvent(config, {
      type: 'smart_link_signup_confirmation',
      targetPath: endpoint,
      target_path: endpoint,
      linkSlug: attribution.linkSlug,
      link_slug: attribution.linkSlug,
      customer: config.customerId,
      shopifyCustomerId: config.customerId,
      shopify_customer_id: config.customerId,
      action: 'signup',
      source: SMART_LINK_SOURCE,
      extraData: {
        action: 'signup',
        source: SMART_LINK_SOURCE,
        shopifyCustomerId: config.customerId,
        shopify_customer_id: config.customerId,
        landingPath: attribution.landingPath,
        landingUrl: attribution.landingUrl,
        capturedAt: attribution.timestamp,
        confirmedPath: window.location.pathname,
        confirmedAt: Date.now(),
        utmParams: attribution.utmParams,
        page: metadata
      }
    })
      .then(function () {
        safeStorageSet(window.localStorage, trackedKey, String(Date.now()));
        safeStorageRemove(window.sessionStorage, SIGNUP_ATTEMPT_KEY);
      })
      .catch(function (error) {
        state.lastSmartLinkError = error && error.message ? error.message : String(error);
        state.smartLinkSignupRequests[trackedKey] = false;
      });
  }

  function startTracking(config) {
    var hasMeta = loadMetaPixel(config.metaPixelId);
    var hasGoogle = loadGoogleTag(config.googleTagId);

    if (hasMeta || hasGoogle) {
      maybeTrackPixelSignup(config);
    }
  }

  function runWhenAllowed(config) {
    if (hasTrackingConsent()) {
      startTracking(config);
    }
  }

  function init() {
    var config = readConfig();
    var checkedCustomerPrivacy = false;

    if (!config) {
      return;
    }

    captureSmartLinkAttribution(config);
    attachSignupSubmitListener();

    withCustomerPrivacy(function () {
      checkedCustomerPrivacy = true;
      runWhenAllowed(config);
      maybeConfirmSmartLinkSignup(config);
    });

    document.addEventListener('visitorConsentCollected', function () {
      runWhenAllowed(config);
    });

    window.setTimeout(function () {
      if (!checkedCustomerPrivacy) {
        maybeConfirmSmartLinkSignup(config);
      }
    }, 500);
  }

  init();
})();
